import React from 'react';

import {ProfileActiveAttribute} from '/component/base/ProfileActiveAttribute';

import {ProfileBusinessItemProps} from './ProfileBusinessSection.types';

export const ProfileBusinessItem = ({
  iconName,
  label,
  onPress,
  accessibilityLabel,
  accessibilityHint,
  testID,
  isLastElement = false,
  status = '',
  disabled = false,
}: ProfileBusinessItemProps) => (
  <ProfileActiveAttribute
    iconName={iconName}
    label={label}
    onPress={onPress}
    accessibilityRole="button"
    accessibilityLabel={accessibilityLabel}
    accessibilityHint={accessibilityHint}
    testID={testID}
    accessible
    isLastElement={isLastElement}
    useCompetency={false}
    status={status}
    disabled={disabled}
    isProfileBusinessSection={true}
  />
);

export default ProfileBusinessItem;
